import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FormattedDate} from '@pb/kit-component-formatters';


export const formatLicenseDate = (dateFormat: string, date?: string) => FormattedDate.format({
    value: date,
    format: mapDateFormat(dateFormat, 'WORD'),
});
